import React, { FC, PropsWithChildren, memo } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal, Typography } from '@mui/material';

import { modalActions } from '@contexts/common/ModalContext';

import {
  styleBackdrop,
  styleBox,
  styleChildren,
  styleClose,
  styleHeader,
} from './styles.module';

interface Props extends PropsWithChildren {
  disableBackdropClick?: boolean;
  isHideCloseBtn?: boolean;
  title?: string;
  onClose?: () => void;
  className?: string;
}

const ModalBox: FC<Props> = ({
  children,
  isHideCloseBtn = false,
  title = '',
  disableBackdropClick = false,
  className = '',
  onClose = undefined,
}) => (
  <Modal
    open
    sx={styleBackdrop}
    onClose={disableBackdropClick ? undefined : onClose || modalActions?.hide}
    className={className}
  >
    <Box sx={styleBox}>
      <Box sx={styleChildren}>
        <Box sx={styleHeader}>
          {title && (
            <Typography
              variant="h4"
              color={(theme) => theme.palette.custom.text.white}
            >
              {title}
            </Typography>
          )}
          {!isHideCloseBtn && (
            <button aria-label="close" onClick={onClose || modalActions?.hide}>
              <CloseIcon sx={styleClose} />
            </button>
          )}
        </Box>
        <Box>{children}</Box>
      </Box>
    </Box>
  </Modal>
);

export default memo(ModalBox);
